import React from 'react';
import Modal from 'react-bootstrap/Modal';
import createTrack from 'services/actions/tracker_actions';
import Logo from 'assets/images/logo-conlicitacao-dark.png';
import Trophy from 'assets/images/campaign-renewal/renewal_trophy.png';
import BellTarget from 'assets/images/campaign-renewal/renewal_bell_target.png';
import CommentBell from 'assets/images/campaign-renewal/renewal_comment_bell.png';
import { Container } from './styles';

interface RenewalProps {
  showModalRenewal: boolean;
  contact_name: string;
  campaign_phase: number;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalRenewal = (props: RenewalProps) => {
  const { setShowModal, showModalRenewal, contact_name, campaign_phase } = props;

  const handleClick = () => {
    createTrack('Renovação online');
    window.open('/renovacao', '_parent');
  };

  return (
    <Modal show={showModalRenewal} size="lg">
      <Container>
        <div className="position-relative bg-modal">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="row p-5">
            <div className="col-md-12 text-center">
              <img src={Logo} alt="ConLicitação" className="my-3" style={{ width: '180px' }} />
            </div>
            {campaign_phase === 1 && (
              <div className="col-md-12">
                <div className="col-md-12">
                  <h3 className="mt-4 mb-4 text-center">
                    <strong>RENOVAÇÃO ANTECIPADA DE ASSINATURA</strong>
                  </h3>
                  <div className="row text-size">
                    <div className="col-md-12 text-center">
                      Informamos que sua <strong>assinatura</strong> no ConLicitação
                    </div>
                    <div className="col-md-12 text-center">
                      entrou no <strong>período de renovação!</strong>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6 text-right pr-0 text-size">
                      E você tem <strong>benefícios</strong> na <br />
                      <strong>renovação antecipada</strong>
                    </div>
                    <div className="col-md-6 text-right pl-0">
                      <img src={Trophy} alt="Renovação antecipada" style={{ height: '275px' }} />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {campaign_phase === 2 && (
              <div className="col-md-12">
                <div className="col-md-12">
                  <h3 className="mt-4 mb-4 text-center">
                    <strong>PERÍODO DE RENOVAÇÃO DE ASSINATURA</strong>
                  </h3>
                  <div className="row text-size">
                    <div className="col-md-12  text-center ">
                      <span className="div_fill">Prezado(a) {contact_name},</span>
                    </div>
                    <div className="col-md-12 text-center">
                      <span className="div_fill">informamos que a assinatura da sua</span>
                    </div>
                    <div className="col-md-12 text-center">
                      <span className="div_fill">empresa vencerá em breve.</span>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6 pr-0 text-size">
                      <strong>O ConLicitação oferece benefícios para a renovação antecipada</strong>
                    </div>
                    <div className="col text-right pl-0">
                      <img
                        src={BellTarget}
                        alt="Renovação antecipada"
                        style={{ height: '275px' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {campaign_phase === 3 && (
              <div className="col-md-12">
                <div className="col-md-12">
                  <h3 className="mt-4 mb-4 text-center">
                    <strong>ATENÇÃO - TEMOS UM AVISO IMPORTANTE</strong>
                  </h3>
                  <div className="row text-size">
                    <div className="col-md-12  text-center mb-3">
                      <strong>Prezado(a) {contact_name},</strong>
                    </div>
                    <div className="col-md-12 text-center">
                      Informamos que a assinatura da sua empresa
                      <strong> está quase expirando</strong>.
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6 pr-0 text-size">
                      Este é o momento ideal para você renovar com a
                      <strong> melhor oferta disponível</strong>
                    </div>
                    <div className="col-md-6 text-right pl-0">
                      <img
                        src={CommentBell}
                        alt="Renovação antecipada"
                        style={{ height: '250px' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="col-md-12 text-center">
              <button
                type="button"
                className="btn btn-renewal mt-4 font-weight-bold"
                onClick={() => handleClick()}
              >
                {campaign_phase === 1 && 'Confira o que preparamos para sua empresa'}
                {campaign_phase === 2 && 'Conheça os benefícios da renovação antecipada'}
                {campaign_phase === 3 && 'Confira o que preparamos para sua empresa'}
              </button>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalRenewal;
